module.exports = __webpack_public_path__ + "static/media/adopets-primary-logo-v2.b42651cb.png";